import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment } from '../aumico-project-reports/src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class MixpanelService {
    constructor() {
        if (environment.mixpanelEnabled) {
            console.log('MixpanelService');
            mixpanel.init(environment.mixpanelToken);
        }
    }

    identify(userEmail: string): void {
        if (environment.mixpanelEnabled) {
            mixpanel.identify(userEmail);
        }
    }

    reset(): void {
        if (environment.mixpanelEnabled) {
            mixpanel.reset();
        }
    }

    track(event: string, params?: any): void {
        console.log('track event', event);
        if (environment.mixpanelEnabled) {
            mixpanel.track(event, params);
        }
    }

    time_event(event: string): void {
        if (environment.mixpanelEnabled) {
            mixpanel.time_event(event);
        }
    }
}
